import React from "react";
import { StyledButton, StyledLink } from "./styledButton";

const ButtonComponent = ({
  isLink,
  to,
  as,
  // type,
  className,
  variant = "primary",
  fontSize,
  disabled,
  children,
  color,
  ...buttonAttributes
}) => {
  if (isLink) {
    return (
      <StyledLink
        to={to}
        className={`btn az-btn btn-${variant} ${className ? className : ""}`}
        fontSize={fontSize ? fontSize : undefined}
        color={color ? color : undefined}
      >
        {children}
      </StyledLink>
    );
  }
  return (
    <StyledButton
      // as={as}
      // type={type}
      className={`az-btn ${className} ${disabled && "border-0"}`}
      variant={variant}
      disabled={disabled}
      fontSize={fontSize}
      color={color ? color : undefined}
      {...buttonAttributes}
    >
      {children}
    </StyledButton>
  );
};

export default ButtonComponent;
